import styled from "@emotion/styled";
import theme from "@theme";

const ValueSpanP = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
  text-align: center;
  justify-content: center;
  align-items: center;
`;
const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;

const Container = styled.div``;

const SC = {
  Container,
  ValueSpanP,
  ValueSpan,
};

export default SC;
